module.exports = __webpack_public_path__ + "img/roman.65a2142c.png";